export function verifyIfPathIsActives(path: string, isSubpage = false): boolean {
  if (!isSubpage) {
    return window.location.pathname.includes(path);
  }

  return window.location.pathname === path;
}
